import { FirestoreCollections, ID } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';

export type DeleteLifeAreaOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  lifeAreaId: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
  onWriteError: (error: unknown) => void;
};

export const deleteLifeArea = async <TDocRef, TDb = FirestoreInstance>(
  options: DeleteLifeAreaOptions<TDocRef, TDb>,
): Promise<void> => {
  const { lifeAreaId, doc, deleteDoc, db, onWriteError } = options;

  const ref = doc(db, FirestoreCollections.LifeAreas, lifeAreaId);
  detachWrite(deleteDoc(ref), onWriteError);
};
